import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
import store from './store/store' // your vuex store

const ifNotAuthenticated = (to, from, next) => {
  if (!localStorage.getItem('lotusToken')) {
    next('/login')
    return
  }
  next()
};

const ifAuthenticated = (to, from, next) => {

  if (localStorage.getItem('lotusToken') === 'null' || !localStorage.getItem('lotusToken')) {
    next('/login')
    localStorage.setItem('lotusToken','null')

  }
  else{
    next()
  }
};
export default new Router({
  mode: 'history',
  // base: this.process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      beforeEnter: ifAuthenticated,
      children: [
        {
          name: 'صفحه اصلی',
          path: '/',
          component: () => import('@/views/dashboard/pages/MainPage'),
          beforeEnter: ifAuthenticated,
        },
        // Pages
        {
          name: 'صفحه اصلی',
          path: 'mainpage/header',
          component: () => import('@/views/dashboard/pages/MainPage'),
          beforeEnter: ifAuthenticated,
        },
        {
          name: 'واحد ها و امکانات',
          path: 'pages/features',
          component: () => import('@/views/dashboard/pages/featuresPage'),
          beforeEnter: ifAuthenticated,
        },

        {
          name: 'خرید و اجاره',
          path: 'pages/rentAndBuy',
          component: () => import('@/views/dashboard/pages/rentAndBuy'),
          beforeEnter: ifAuthenticated,
        },
        {
          name: 'معرفی',
          path: 'pages/IntroducePage',
          component: () => import('@/views/dashboard/pages/IntroducePage'),
          beforeEnter: ifAuthenticated,
        },
        // Tables
        // {
        //   name: 'جشنواره',
        //   path: 'pages/miladNoor',
        //   component: () => import('@/views/dashboard/pages/miladNoor'),
        //   beforeEnter: ifAuthenticated,
        // },
        {
          name: 'اخبار',
          path: 'news',
          component: () => import('@/views/dashboard/pages/news'),
          beforeEnter: ifAuthenticated,
        },
        {
          name: 'فروشگاه ها',
          path: 'shops',
          component: () => import('@/views/dashboard/component/shops'),
          beforeEnter: ifAuthenticated,
        },
        {
          name: 'تماس با ما',
          path: 'contact',
          component: () => import('@/views/dashboard/component/contact'),
          beforeEnter: ifAuthenticated,
        },


      ],
    },
    {
      path: '/login',
      component : () => import('@/views/dashboard/pages/loginPage'),
      beforeEnter: ifNotAuthenticated
    }
  ],
})
